import React from 'react'

interface GemIconProps {
    packageName?: string
    className?: string
}

export const GemIcon = ({ packageName, className = "h-5 w-auto" }: GemIconProps) => {
    const value = packageName?.toLowerCase() || ''

    // Premium Gem (Blue)
    if (value === 'premium') {
        return (
            <svg 
                viewBox="0 0 300 252" 
                xmlns="http://www.w3.org/2000/svg" 
                className={className} 
                aria-hidden="true"
            >
                <polygon points="6,96 72,8 150,96" fill="#45bff5"/>
                <polygon points="72,8 228,8 150,96" fill="#a6e2fa"/>
                <polygon points="228,8 294,96 150,96" fill="#78d0f7"/>
                <polygon points="6,96 150,96 150,248" fill="#29aef1"/>
                <polygon points="150,96 222,96 150,248" fill="#56c6f6"/>
                <polygon points="222,96 294,96 150,248" fill="#38b6f3"/>
            </svg>
        )
    }

    // Pro Gem (Bronze / Brown)
    if (value === 'pro') {
        return (
            <svg 
                viewBox="0 0 300 252" 
                xmlns="http://www.w3.org/2000/svg" 
                className={className} 
                aria-hidden="true"
            >
                <polygon points="6,96 72,8 150,96" fill="#bc8b78"/>
                <polygon points="72,8 228,8 150,96" fill="#cba593"/>
                <polygon points="228,8 294,96 150,96" fill="#e6c3ae"/>
                <polygon points="6,96 150,96 150,248" fill="#bc7f61"/>
                <polygon points="150,96 222,96 150,248" fill="#c78e73"/>
                <polygon points="222,96 294,96 150,248" fill="#b3785c"/>
            </svg>
        )
    }

    // Basic / Free Gem (Gray / Silver)
    return (
        <svg 
            viewBox="0 0 300 252" 
            xmlns="http://www.w3.org/2000/svg" 
            className={className} 
            aria-hidden="true"
        >
            <polygon points="6,96 72,8 150,96" fill="#9a9ea3"/>
            <polygon points="72,8 228,8 150,96" fill="#c3c4c9"/>
            <polygon points="228,8 294,96 150,96" fill="#d4d5d9"/>
            <polygon points="6,96 150,96 150,248" fill="#868d96"/>
            <polygon points="150,96 222,96 150,248" fill="#9aa0a8"/>
            <polygon points="222,96 294,96 150,248" fill="#7e858f"/>
        </svg>
    )
}